import React from 'react';
import SectionHeader from './SectionHeader';
import Field from './Field';
import InputSuffix from './InputSuffix';
import styles from '../SaleReportPage.module.scss';
import { buildLandRows } from '../fieldBuilders';

const GridIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="1" />
    <path d="M3 9h18M3 15h18M9 3v18M15 3v18" />
  </svg>
);

function LandSection({ config, sale, onChange }) {
  const fields = config.fields || {};

  const setField = (key, val) => {
    onChange({ ...config, fields: { ...fields, [key]: val } });
  };

  const setVal = (key, val) => {
    onChange({ ...config, fields: { ...fields, [key + '_edit']: val } });
  };

  if (!sale) return null;

  const rows = buildLandRows(sale, config);

  return (
    <>
      <SectionHeader
        icon={<GridIcon />}
        title="토지 정보"
      />
      <div className={styles.grid}>
        {rows.map(({ key, label, value, unit, sub }) => (
          <Field
            key={key}
            label={label}
            span={4}
            toggle
            toggleEnabled={fields[key]}
            onToggle={(v) => setField(key, v)}
            hint={sub || undefined}
          >
            {unit ? (
              <InputSuffix
                value={value === '-' ? '' : value}
                unit={unit}
                onChange={(v) => setVal(key, v)}
              />
            ) : (
              <input
                type="text"
                value={value === '-' ? '' : value}
                onChange={(e) => setVal(key, e.target.value)}
              />
            )}
          </Field>
        ))}
      </div>
    </>
  );
}

export default LandSection;
